// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/**
 * 获取房产列表
 */
export async function getPropertyList(params: OA.PropertyListParams) {
  return request<OA.ApiResponse<OA.PaginatedResponse<OA.Property>>>('/api/v1/properties/', {
    method: 'GET',
    params,
  });
}

/**
 * 获取房产统计信息
 */
export async function getPropertyStatistics() {
  return request<OA.ApiResponse<OA.PropertyStatistics>>('/api/v1/properties/statistics', {
    method: 'GET',
  });
}

/**
 * 获取房产详情
 */
export async function getPropertyDetail(propertyId: number) {
  return request<OA.ApiResponse<OA.PropertyDetail>>(`/api/v1/properties/${propertyId}`, {
    method: 'GET',
  });
}

/**
 * 创建房产
 */
export async function createProperty(data: OA.PropertyCreate) {
  return request<OA.ApiResponse<OA.Property>>('/api/v1/properties/', {
    method: 'POST',
    data,
  });
}

/**
 * 更新房产
 */
export async function updateProperty(propertyId: number, data: OA.PropertyUpdate) {
  return request<OA.ApiResponse<OA.Property>>(`/api/v1/properties/${propertyId}`, {
    method: 'PUT',
    data,
  });
}

/**
 * 删除房产
 */
export async function deleteProperty(propertyId: number) {
  return request<OA.ApiResponse<null>>(`/api/v1/properties/${propertyId}`, {
    method: 'DELETE',
  });
}

/**
 * 获取房产的租赁物列表
 */
export async function getPropertyRentalItems(
  propertyId: number,
  params?: OA.RentalItemListParams,
) {
  return request<OA.ApiResponse<OA.PaginatedResponse<OA.RentalItem>>>(
    `/api/v1/properties/${propertyId}/rental-items`,
    {
      method: 'GET',
      params,
    },
  );
}

/**
 * 为房产创建租赁物
 */
export async function createPropertyRentalItem(propertyId: number, data: OA.RentalItemCreate) {
  return request<OA.ApiResponse<OA.RentalItem>>(
    `/api/v1/properties/${propertyId}/rental-items`,
    {
      method: 'POST',
      data: { ...data, property_id: propertyId },
    },
  );
}

/**
 * 创建租赁物（独立接口，需要在请求体中指定 property_id）
 */
export async function createRentalItem(data: OA.RentalItemCreate) {
  return request<OA.ApiResponse<OA.RentalItem>>(
    `/api/v1/properties/${data.property_id}/rental-items`,
    {
      method: 'POST',
      data,
    },
  );
}

/**
 * 获取所有租赁物列表
 */
export async function getRentalItemList(params?: OA.RentalItemListParams) {
  return request<OA.ApiResponse<OA.PaginatedResponse<OA.RentalItem>>>(
    '/api/v1/properties/rental-items/list',
    {
      method: 'GET',
      params,
    },
  );
}

/**
 * 获取租赁物详情
 */
export async function getRentalItemDetail(rentalItemId: number) {
  return request<OA.ApiResponse<OA.RentalItem>>(
    `/api/v1/properties/rental-items/${rentalItemId}`,
    {
      method: 'GET',
    },
  );
}

/**
 * 更新租赁物
 */
export async function updateRentalItem(rentalItemId: number, data: OA.RentalItemUpdate) {
  return request<OA.ApiResponse<OA.RentalItem>>(
    `/api/v1/properties/rental-items/${rentalItemId}`,
    {
      method: 'PUT',
      data,
    },
  );
}

/**
 * 删除租赁物
 */
export async function deleteRentalItem(rentalItemId: number) {
  return request<OA.ApiResponse<null>>(`/api/v1/properties/rental-items/${rentalItemId}`, {
    method: 'DELETE',
  });
}

/**
 * 获取房产出租统计
 */
export async function getRentalStatistics() {
  return request<OA.ApiResponse<OA.RentalStatisticsData>>('/api/v1/properties/statistics/rental', {
    method: 'GET',
  });
}

/**
 * 获取房产应收款统计
 */
export async function getReceivableStatistics(params?: OA.ReceivableStatisticsParams) {
  return request<OA.ApiResponse<OA.ReceivableStatisticsData>>('/api/v1/properties/statistics/receivable', {
    method: 'GET',
    params,
  });
}

